document.addEventListener('DOMContentLoaded', () => {
  function showForm() {
    const form = document.querySelector('[data-form]');
    if (form) {
      form.classList.add('active');
    }
  }

  document.querySelectorAll('[data-form-toggler]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      showForm();
    });
  });
})